
export class ItemGroupFilter{
    ItemGroupId:number;
   
    constructor( ItemGroupId:number ){
        this.ItemGroupId = ItemGroupId
    }
}